import { useQueryClient, useMutation } from 'react-query'
import { type PersonType } from '../../../../enumns/personType'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'
import { api } from '../../../api'

const updateExpertData = async (
  id: number,
  expertData: Partial<ExpertDomain>
): Promise<ExpertDomain> => {
  const response = await api.put<ExpertDomain>(`/experts/${id}`, expertData)
  return response.data
}

export const useUpdateExpertDataMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn({
      id,
      expertData,
    }: {
      id: number
      expertData: Partial<ExpertDomain>
    }) {
      return updateExpertData(id, expertData)
    },
    onSuccess(data: ExpertDomain) {
      queryClient.setQueryData(['expert', data.id], data)
    },
  })
}
